export default "__VITE_ASSET__BpOe5WYD__"